/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Insert_Speaker_TitleInputs */



/**
* | output |
* | --- |
* | "Insert Speaker Name" |
*
* @param {Insert_Speaker_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const insert_speaker_title = /** @type {((inputs?: Insert_Speaker_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insert_Speaker_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Insérer le nom du locuteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Name des Sprechers einfügen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci il nome dell'oratore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставьте имя докладчика")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar nombre del orador")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("插入演讲者姓名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカー名を挿入")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ता का नाम डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira o nome do palestrante")
	return /** @type {LocalizedString} */ ("Insert Speaker Name")
});